import { create } from 'zustand';
import { trimAPI } from '../utils/axios';
import { handleApiError } from '../utils/errorHandler';

const useTrimStore = create((set, get) => ({
  // 상태
  selectedFile: '',
  availableFiles: [],
  
  // 분석 결과
  columnStructure: null,
  columns: [],
  isAnalyzing: false,
  analysisError: null,
  
  // 컬럼 선택
  selectedColumns: [],
  selectAll: false,
  
  // 미리보기
  previewData: null,
  isLoadingPreview: false,
  previewError: null,
  
  // 파일 생성
  outputFileName: 'selected_data',
  isGenerating: false,
  generationError: null,
  downloadLink: null,

  // 🆕 트리 관련 상태 추가
  treeData: null,
  terminalNodes: [],
  checkedNodes: new Set(),

  // 🆕 선택된 컬럼 트리 관련 새로운 상태들
  selectedTreeData: null,         // 선택된 터미널 노드들로 만든 트리
  selectedCheckedNodes: new Set(), // 선택된 트리에서 체크된 노드들
  finalSelectedNodes: [],          // 최종 선택된 노드들

  // 액션들
  setSelectedFile: (file) => {
    set({ 
      selectedFile: file,
      // 파일 변경 시 관련 상태 초기화
      columnStructure: null,
      columns: [],
      selectedColumns: [],
      selectAll: false,
      previewData: null,
      analysisError: null,
      previewError: null,
      generationError: null
    });
  },

  setAvailableFiles: (files) => {
    set({ availableFiles: files });
  },

  setOutputFileName: (fileName) => {
    set({ outputFileName: fileName });
  },

  // 🆕 트리 관련 액션들
  setTreeData: (treeData) => {
    set({ treeData });
  },

  setTerminalNodes: (terminalNodes) => {
    set({ terminalNodes });
  },

  setCheckedNodes: (checkedNodes) => {
    set({ checkedNodes });
  },

syncFinalSelectedNodesWithTerminalNodes: () => {
  const { terminalNodes, finalSelectedNodes } = get();
  
  if (finalSelectedNodes.length === 0) {
    // finalSelectedNodes가 비어있으면 동기화할 필요 없음
    return;
  }
  
  //console.log('🔥 [DEBUG] syncFinalSelectedNodesWithTerminalNodes 시작');
  //console.log('🔥 [DEBUG] 현재 terminalNodes:', terminalNodes);
  //console.log('🔥 [DEBUG] 현재 finalSelectedNodes:', finalSelectedNodes);
  
  // terminalNodes에서 현재 존재하는 노드들의 고유 식별자 세트 생성
  const currentTerminalNodeKeys = new Set(
    terminalNodes.map(node => {
      // 노드를 고유하게 식별할 수 있는 키 생성 (path + col + row)
      return JSON.stringify({
        path: node.path || [],
        col: node.col,
        row: node.row,
        name: node.name
      });
    })
  );
  
  // finalSelectedNodes에서 terminalNodes에 더 이상 존재하지 않는 노드들 제거
  const updatedFinalSelectedNodes = finalSelectedNodes.filter(finalNode => {
    const finalNodeKey = JSON.stringify({
      path: finalNode.path || [],
      col: finalNode.col,
      row: finalNode.row,
      name: finalNode.name
    });
    
    const shouldKeep = currentTerminalNodeKeys.has(finalNodeKey);
    
    if (!shouldKeep) {
      //console.log('🔥 [DEBUG] finalSelectedNodes에서 제거됨:', finalNode.name, finalNode.path);
    }
    
    return shouldKeep;
  });
  
  //console.log('🔥 [DEBUG] 동기화 후 finalSelectedNodes:', updatedFinalSelectedNodes);
  
  // finalSelectedNodes가 변경되었다면 업데이트
  if (updatedFinalSelectedNodes.length !== finalSelectedNodes.length) {
    set({ finalSelectedNodes: updatedFinalSelectedNodes });
    
    // selectedCheckedNodes도 함께 업데이트 (finalSelectedNodes와 일관성 유지)
    get().updateSelectedCheckedNodesFromFinalNodes(updatedFinalSelectedNodes);
  }
},

updateSelectedCheckedNodesFromFinalNodes: (finalNodes) => {
  const { selectedTreeData } = get();
  
  if (!selectedTreeData) {
    set({ selectedCheckedNodes: new Set() });
    return;
  }
  
  const newSelectedCheckedNodes = new Set();
  
  // selectedTreeData를 순회하면서 finalNodes에 포함된 노드들을 찾아서 체크 상태로 설정
  const traverseAndCheck = (node) => {
    if (!node) return;
    
    // 현재 노드가 finalNodes에 포함되어 있는지 확인
    const isInFinalNodes = finalNodes.some(finalNode => {
      return JSON.stringify({
        path: finalNode.path || [],
        col: finalNode.col,
        row: finalNode.row,
        name: finalNode.name
      }) === JSON.stringify({
        path: node.originalTerminalNode?.path || [],
        col: node.originalTerminalNode?.col || node.col,
        row: node.originalTerminalNode?.row || node.row,
        name: node.originalTerminalNode?.name || node.name
      });
    });
    
    if (isInFinalNodes) {
      newSelectedCheckedNodes.add(JSON.stringify(node));
    }
    
    // 자식 노드들도 재귀적으로 처리
    if (node.children) {
      node.children.forEach(traverseAndCheck);
    }
  };
  
  traverseAndCheck(selectedTreeData);
  
  set({ selectedCheckedNodes: newSelectedCheckedNodes });
},


  // toggleNode: (node) => {
  //   const { checkedNodes } = get();
  //   const newCheckedNodes = new Set(checkedNodes);
    
  //   const updateChildren = (node, checked) => {
  //     if (checked) {
  //       newCheckedNodes.add(JSON.stringify(node));
  //     } else {
  //       newCheckedNodes.delete(JSON.stringify(node));
  //     }

  //     if (node.children) {
  //       node.children.forEach(child => updateChildren(child, checked));
  //     }
  //   };

  //   const nodeKey = JSON.stringify(node);
  //   if (newCheckedNodes.has(nodeKey)) {
  //     newCheckedNodes.delete(nodeKey);
  //     updateChildren(node, false);
  //   } else {
  //     newCheckedNodes.add(nodeKey);
  //     updateChildren(node, true);
  //   }

  //   set({ checkedNodes: newCheckedNodes });
    
  //   // 터미널 노드 추출
  //   const terminalNodes = get().extractTerminalNodes(newCheckedNodes);
  //   set({ terminalNodes });

  //   const selectedTreeData = get().buildSelectedTree(terminalNodes);
  //   set({ selectedTreeData });
  // },

toggleNode: (node) => {
  //console.log('🔥 [DEBUG] toggleNode 호출됨:', node);
  
  const { checkedNodes } = get();
  //console.log('🔥 [DEBUG] 현재 checkedNodes:', Array.from(checkedNodes));
  
  const newCheckedNodes = new Set(checkedNodes);
  
  const updateChildren = (node, checked) => {
    if (checked) {
      newCheckedNodes.add(JSON.stringify(node));
    } else {
      newCheckedNodes.delete(JSON.stringify(node));
    }

    if (node.children) {
      node.children.forEach(child => updateChildren(child, checked));
    }
  };

  const nodeKey = JSON.stringify(node);
  const wasChecked = newCheckedNodes.has(nodeKey);
  
  if (wasChecked) {
    newCheckedNodes.delete(nodeKey);
    updateChildren(node, false);
    //console.log('🔥 [DEBUG] 노드 선택 해제:', node.name);
  } else {
    newCheckedNodes.add(nodeKey);
    updateChildren(node, true);
    //console.log('🔥 [DEBUG] 노드 선택:', node.name);
  }

  //console.log('🔥 [DEBUG] 새로운 checkedNodes:', Array.from(newCheckedNodes));
  set({ checkedNodes: newCheckedNodes });
  
  // 터미널 노드 추출
  const terminalNodes = get().extractTerminalNodes(newCheckedNodes);
  //console.log('🔥 [DEBUG] 추출된 terminalNodes:', terminalNodes);
  set({ terminalNodes });

  // selectedTreeData 생성
  const selectedTreeData = get().buildSelectedTree(terminalNodes);
  //console.log('🔥 [DEBUG] 생성된 selectedTreeData:', selectedTreeData);
  set({ selectedTreeData });
  
  // 🆕 중요: terminalNodes 변경에 따른 finalSelectedNodes 동기화
  get().syncFinalSelectedNodesWithTerminalNodes();
},


  // 🆕 선택된 터미널 노드들로 트리 구조 생성
  // buildSelectedTree: (terminalNodes) => {
  //   if (!terminalNodes || terminalNodes.length === 0) {
  //     return null;
  //   }

  //   const root = { name: "SelectedRoot", children: [] };

  //   terminalNodes.forEach(terminalNode => {
  //     if (!terminalNode.path || terminalNode.path.length === 0) {
  //       return;
  //     }

  //     // 경로를 따라 트리 구축
  //     let currentParent = root;
      
  //     terminalNode.path.forEach((pathSegment, index) => {
  //       // 현재 부모의 자식 중에서 같은 이름을 가진 노드 찾기
  //       let existingChild = currentParent.children.find(child => child.name === pathSegment);
        
  //       if (!existingChild) {
  //         // 새 노드 생성
  //         const newNode = {
  //           name: pathSegment,
  //           children: [],
  //           // 마지막 경로 세그먼트인 경우 터미널 노드 정보 포함
  //           ...(index === terminalNode.path.length - 1 && {
  //             row: terminalNode.row,
  //             col: terminalNode.col,
  //             isTerminal: true,
  //             originalTerminalNode: terminalNode
  //           })
  //         };
          
  //         currentParent.children.push(newNode);
  //         currentParent = newNode;
  //       } else {
  //         currentParent = existingChild;
          
  //         // 마지막 세그먼트인 경우 터미널 정보 업데이트
  //         if (index === terminalNode.path.length - 1) {
  //           existingChild.row = terminalNode.row;
  //           existingChild.col = terminalNode.col;
  //           existingChild.isTerminal = true;
  //           existingChild.originalTerminalNode = terminalNode;
  //         }
  //       }
  //     });
  //   });

  //   return root;
  // },

   buildSelectedTree: (terminalNodes) => {
    //console.log('🔥 [DEBUG] buildSelectedTree 호출됨:', terminalNodes);
    
    if (!terminalNodes || terminalNodes.length === 0) {
      //console.log('🔥 [DEBUG] terminalNodes가 비어있음');
      return null;
    }

    const root = { name: "SelectedRoot", children: [] };

    terminalNodes.forEach(terminalNode => {
      //console.log('🔥 [DEBUG] 처리 중인 terminalNode:', terminalNode);
      
      if (!terminalNode.path || terminalNode.path.length === 0) {
        //console.log('🔥 [DEBUG] path가 없는 노드 스킵:', terminalNode);
        return;
      }

      // 경로를 따라 트리 구축
      let currentParent = root;
      
      terminalNode.path.forEach((pathSegment, index) => {
        //console.log(`🔥 [DEBUG] 경로 세그먼트 [${index}]:`, pathSegment);
        
        // 현재 부모의 자식 중에서 같은 이름을 가진 노드 찾기
        let existingChild = currentParent.children.find(child => child.name === pathSegment);
        
        if (!existingChild) {
          // 새 노드 생성
          const newNode = {
            name: pathSegment,
            children: [],
            // 마지막 경로 세그먼트인 경우 터미널 노드 정보 포함
            ...(index === terminalNode.path.length - 1 && {
              row: terminalNode.row,
              col: terminalNode.col,
              isTerminal: true,
              originalTerminalNode: terminalNode
            })
          };
          
          //console.log(`🔥 [DEBUG] 새 노드 생성:`, newNode);
          currentParent.children.push(newNode);
          currentParent = newNode;
        } else {
          //console.log(`🔥 [DEBUG] 기존 노드 재사용:`, existingChild.name);
          currentParent = existingChild;
          
          // 마지막 세그먼트인 경우 터미널 정보 업데이트
          if (index === terminalNode.path.length - 1) {
            existingChild.row = terminalNode.row;
            existingChild.col = terminalNode.col;
            existingChild.isTerminal = true;
            existingChild.originalTerminalNode = terminalNode;
          }
        }
      });
    });

    //console.log('🔥 [DEBUG] 최종 생성된 트리:', root);
    return root;
  },

  // 🆕 선택된 트리에서 노드 토글
  toggleSelectedNode: (node) => {
    const { selectedCheckedNodes } = get();
    const newSelectedCheckedNodes = new Set(selectedCheckedNodes);
    
    const updateChildren = (node, checked) => {
      if (checked) {
        newSelectedCheckedNodes.add(JSON.stringify(node));
      } else {
        newSelectedCheckedNodes.delete(JSON.stringify(node));
      }

      if (node.children) {
        node.children.forEach(child => updateChildren(child, checked));
      }
    };

    const nodeKey = JSON.stringify(node);
    if (newSelectedCheckedNodes.has(nodeKey)) {
      newSelectedCheckedNodes.delete(nodeKey);
      updateChildren(node, false);
    } else {
      newSelectedCheckedNodes.add(nodeKey);
      updateChildren(node, true);
    }

    set({ selectedCheckedNodes: newSelectedCheckedNodes });
    
    // 🆕 최종 선택된 터미널 노드들 추출
    const finalSelectedNodes = get().extractFinalSelectedNodes(newSelectedCheckedNodes);
    //console.log('🔥 [DEBUG] 추출된 finalSelectedNodes:', finalSelectedNodes);
    set({ finalSelectedNodes });
  },

calculateDisplayPath: (terminalNode, selectedCheckedNodes) => {
  if (!terminalNode.path || terminalNode.path.length === 0) {
    return [terminalNode.name];
  }
  
  // selectedCheckedNodes는 Set이므로 Array로 변환하여 처리
  const checkedNodesArray = Array.from(selectedCheckedNodes).map(nodeStr => JSON.parse(nodeStr));
  
  // 체크된 노드들 중에서 현재 터미널 노드의 경로에 실제로 체크된 노드들만 찾기
  const actuallyCheckedNodes = checkedNodesArray.filter(checkedNode => {
    // path가 없는 경우 originalTerminalNode의 path 사용하거나 노드 이름으로 경로 구성
    let nodePath;
    if (checkedNode.path) {
      nodePath = checkedNode.path;
    } else if (checkedNode.originalTerminalNode && checkedNode.originalTerminalNode.path) {
      nodePath = checkedNode.originalTerminalNode.path;
    } else {
      // path 정보가 없으면 노드 이름으로 경로 추정
      nodePath = [checkedNode.name];
    }
    
    // 체크된 노드의 이름이 터미널 노드의 경로에 포함되는지 확인
    // (경로 순서가 아닌 포함 여부만 확인)
    const nodeName = nodePath[nodePath.length - 1] || checkedNode.name;
    const isInTerminalPath = terminalNode.path.includes(nodeName);
    
    return isInTerminalPath;
  });
  
  if (actuallyCheckedNodes.length === 0) {
    // 체크된 노드가 없으면 전체 경로 사용
    return terminalNode.path;
  }
  
  // 체크된 노드들을 터미널 노드 경로에서의 순서대로 정렬
  const sortedCheckedNodes = actuallyCheckedNodes.sort((a, b) => {
    const aName = (a.path && a.path[a.path.length - 1]) || 
                  (a.originalTerminalNode && a.originalTerminalNode.path && a.originalTerminalNode.path[a.originalTerminalNode.path.length - 1]) || 
                  a.name;
    const bName = (b.path && b.path[b.path.length - 1]) || 
                  (b.originalTerminalNode && b.originalTerminalNode.path && b.originalTerminalNode.path[b.originalTerminalNode.path.length - 1]) || 
                  b.name;
    
    // 터미널 노드 경로에서의 인덱스로 정렬
    const aIndex = terminalNode.path.indexOf(aName);
    const bIndex = terminalNode.path.indexOf(bName);
    
    return aIndex - bIndex;
  });
  
  // 체크된 노드들의 이름만 순서대로 추출
  const displayPath = sortedCheckedNodes.map(node => {
    // path의 마지막 세그먼트 또는 노드 이름 사용
    if (node.path && node.path.length > 0) {
      return node.path[node.path.length - 1];
    } else if (node.originalTerminalNode && node.originalTerminalNode.path && node.originalTerminalNode.path.length > 0) {
      return node.originalTerminalNode.path[node.originalTerminalNode.path.length - 1];
    } else {
      return node.name;
    }
  });
  
  // 중복 제거하면서 순서 유지
  const uniqueDisplayPath = [...new Set(displayPath)];
  
  return uniqueDisplayPath.length > 0 ? uniqueDisplayPath : terminalNode.path;
},

// 2. extractFinalSelectedNodes 함수에서 calculateDisplayPath 호출 부분 수정
extractFinalSelectedNodes: (selectedCheckedNodes) => {
  const checkedNodesArray = Array.from(selectedCheckedNodes).map(nodeStr => JSON.parse(nodeStr));
  
  const { selectedTreeData } = get();
  if (!selectedTreeData) return [];
  
  // selectedTreeData에서 모든 터미널 노드들을 먼저 수집
  const getAllTerminalNodesFromTree = (node) => {
    if (node.isTerminal && node.originalTerminalNode) {
      return [node.originalTerminalNode];
    }
    
    if (!node.children || node.children.length === 0) {
      return [];
    }
    
    return node.children.flatMap(getAllTerminalNodesFromTree);
  };
  
  const allAvailableTerminalNodes = getAllTerminalNodesFromTree(selectedTreeData);
  
  // 체크된 노드들 중에서 터미널 노드인 것들만 필터링
  const checkedTerminalNodes = checkedNodesArray
    .filter(checkedNode => {
      return checkedNode.isTerminal && checkedNode.originalTerminalNode;
    })
    .map(checkedNode => checkedNode.originalTerminalNode);
  
  // 체크된 부모 노드들의 자식 터미널 노드들도 포함
  const parentCheckedTerminalNodes = checkedNodesArray
    .filter(checkedNode => {
      return checkedNode.children && checkedNode.children.length > 0;
    })
    .flatMap(parentNode => {
      return allAvailableTerminalNodes.filter(terminalNode => {
        if (!terminalNode.path || !parentNode.path) return false;
        
        return terminalNode.path.length > parentNode.path.length &&
               parentNode.path.every((pathPart, index) => 
                 terminalNode.path[index] === pathPart
               );
      });
    });
  
  const finalTerminalNodes = [...checkedTerminalNodes, ...parentCheckedTerminalNodes];
  
  // 🔥 수정: calculateDisplayPath 호출 시 selectedCheckedNodes 직접 전달
  const finalNodesWithDisplayPath = finalTerminalNodes.map(terminalNode => {
    const displayPath = get().calculateDisplayPath(terminalNode, selectedCheckedNodes);
    
    return {
      ...terminalNode,
      originalPath: terminalNode.path, // 전체 경로 (컬럼 매칭용)
      displayPath: displayPath,        // 표시용 경로 (컬럼명 생성용)
      originalName: terminalNode.name, // 원본 이름
      displayName: displayPath.length > 0 ? displayPath[displayPath.length - 1] : terminalNode.name
    };
  });
  
  // 중복 제거
  const uniqueFinalNodes = Array.from(
    new Set(finalNodesWithDisplayPath.map(node => JSON.stringify({
      originalPath: node.originalPath,
      col: node.col,
      row: node.row
    })))
  ).map(nodeStr => {
    const nodeKey = JSON.parse(nodeStr);
    return finalNodesWithDisplayPath.find(node => 
      JSON.stringify({
        originalPath: node.originalPath,
        col: node.col,
        row: node.row
      }) === nodeStr
    );
  });

  return uniqueFinalNodes;
},

extractTerminalNodes: (checkedNodes) => {
  //console.log('🔥 [DEBUG] extractTerminalNodes 호출됨:', Array.from(checkedNodes));
  
  const { treeData } = get(); // 원본 트리 데이터 가져오기
  
  if (!treeData) {
    //console.log('🔥 [DEBUG] treeData가 없어서 빈 배열 반환');
    return [];
  }
  
  const checkedNodesArray = Array.from(checkedNodes).map(nodeStr => JSON.parse(nodeStr));
  //console.log('🔥 [DEBUG] 체크된 노드들:', checkedNodesArray);
  
  // 🆕 전체 트리를 순회하며 체크된 노드들의 경로를 찾는 함수
  const findNodePathsInTree = (node, currentPath = []) => {
    const newPath = node.name !== "Root" ? [...currentPath, node.name] : currentPath;
    
    // 현재 노드가 체크된 노드인지 확인
    const isChecked = checkedNodesArray.some(checkedNode => 
      JSON.stringify(checkedNode) === JSON.stringify(node)
    );
    
    let results = [];
    
    // 체크된 노드이고 터미널 노드인 경우
    if (isChecked && (!node.children || node.children.length === 0)) {
      const terminalNodeWithPath = {
        ...node,
        path: newPath
      };
      //console.log('🔥 [DEBUG] 경로를 포함한 터미널 노드 발견:', terminalNodeWithPath);
      results.push(terminalNodeWithPath);
    }
    
    // 체크된 노드이고 자식이 있는 경우, 모든 터미널 자식들을 찾기
    if (isChecked && node.children && node.children.length > 0) {
      const getAllTerminalChildren = (childNode, childPath) => {
        const fullChildPath = [...childPath, childNode.name];
        
        if (!childNode.children || childNode.children.length === 0) {
          // 터미널 자식 노드
          return [{
            ...childNode,
            path: fullChildPath
          }];
        }
        
        // 더 깊은 자식들 탐색
        return childNode.children.flatMap(grandChild => 
          getAllTerminalChildren(grandChild, fullChildPath)
        );
      };
      
      const terminalChildren = node.children.flatMap(child => 
        getAllTerminalChildren(child, newPath)
      );
      
      //console.log('🔥 [DEBUG] 체크된 부모 노드의 터미널 자식들:', terminalChildren);
      results.push(...terminalChildren);
    }
    
    // 자식 노드들도 재귀적으로 탐색 (체크되지 않은 노드라도)
    if (node.children && node.children.length > 0) {
      const childResults = node.children.flatMap(child => 
        findNodePathsInTree(child, newPath)
      );
      results.push(...childResults);
    }
    
    return results;
  };
  
  // 전체 트리에서 터미널 노드들 찾기
  const terminalNodes = findNodePathsInTree(treeData);
  
  // 중복 제거
  const uniqueTerminalNodes = Array.from(
    new Set(terminalNodes.map(node => JSON.stringify(node)))
  ).map(nodeStr => JSON.parse(nodeStr));

  //console.log('🔥 [DEBUG] 최종 추출된 terminalNodes (경로 포함):', uniqueTerminalNodes);
  return uniqueTerminalNodes;
},

clearTreeStates: () => {
  //console.log('[TRIM_STORE] 🔥 트리 상태 초기화 시작');
  
  set({
    // 트리 관련 상태 초기화
    treeData: null,
    terminalNodes: [],
    checkedNodes: new Set(),
    selectedTreeData: null,
    selectedCheckedNodes: new Set(),
    finalSelectedNodes: [],
    
    // 분석 관련 상태도 함께 초기화
    columnStructure: null,
    columns: [],
    selectedColumns: [],
    selectAll: false,
    
    // 미리보기 및 에러 상태 초기화
    previewData: null,
    analysisError: null,
    previewError: null,
    generationError: null
  });
  
  //console.log('[TRIM_STORE] 🔥 트리 상태 초기화 완료');
},

  clearTreeStates: () => {
    //console.log('[TRIM_STORE] 🔥 트리 상태 초기화 시작');
    
    set({
      // 트리 관련 상태 초기화
      treeData: null,
      terminalNodes: [],
      checkedNodes: new Set(),
      selectedTreeData: null,
      selectedCheckedNodes: new Set(),
      finalSelectedNodes: [],
      
      // 분석 관련 상태도 함께 초기화
      columnStructure: null,
      columns: [],
      selectedColumns: [],
      selectAll: false,
      
      // 미리보기 및 에러 상태 초기화
      previewData: null,
      analysisError: null,
      previewError: null,
      generationError: null
    });
    
    //console.log('[TRIM_STORE] 🔥 트리 상태 초기화 완료');
  },

  // 파일 분석
  analyzeFile: async (fileId, headerRows = 6) => {

    set({ isAnalyzing: true, analysisError: null });
    
    try {
      //console.log('[TRIM_STORE]', 'Analyzing file:', fileId);
      
      const result = await trimAPI.analyzeFile(fileId, headerRows);
      
      if (result.success) {
        const columns = result.data.columns || [];
        
        set({
          columnStructure: result.data,
          columns: columns,
          treeData: result.data.tree_data, // 🆕 트리 데이터 저장
          isAnalyzing: false,
          analysisError: null
        });
        
        //console.log('[TRIM_STORE]', 'Analysis completed:', columns.length, 'columns');
        return { success: true, data: result.data };
      } else {
        throw new Error(result.message);
      }
      
    } catch (error) {
      console.error('[TRIM_STORE]', 'Analysis error:', error);
      const errorInfo = handleApiError(error);
      
      set({
        isAnalyzing: false,
        analysisError: errorInfo.message,
        columnStructure: null,
        columns: [],
        treeData: null // 🆕 트리 데이터도 초기화
      });
      
      return { success: false, error: errorInfo.message };
    }
  },

  // 컬럼 선택/해제
  toggleColumn: (columnId) => {
    const { columns, selectedColumns } = get();
    
    const column = columns.find(col => col.id === columnId);
    if (!column) return;
    
    const isSelected = selectedColumns.some(col => col.id === columnId);
    
    let newSelectedColumns;
    if (isSelected) {
      // 선택 해제
      newSelectedColumns = selectedColumns.filter(col => col.id !== columnId);
    } else {
      // 선택 추가
      newSelectedColumns = [...selectedColumns, { ...column, selected: true }];
    }
    
    // 전체 선택 상태 업데이트
    const newSelectAll = newSelectedColumns.length === columns.length;
    
    set({
      selectedColumns: newSelectedColumns,
      selectAll: newSelectAll
    });
    
    //console.log('[TRIM_STORE]', 'Column toggled:', columnId, 'Selected:', newSelectedColumns.length);
  },

  // 전체 선택/해제
  toggleSelectAll: () => {
    const { columns, selectAll } = get();
    
    let newSelectedColumns;
    let newSelectAll;
    
    if (selectAll) {
      // 전체 해제
      newSelectedColumns = [];
      newSelectAll = false;
    } else {
      // 전체 선택
      newSelectedColumns = columns.map(col => ({ ...col, selected: true }));
      newSelectAll = true;
    }
    
    set({
      selectedColumns: newSelectedColumns,
      selectAll: newSelectAll
    });
    
    //console.log('[TRIM_STORE]', 'Select all toggled:', newSelectAll, 'Selected:', newSelectedColumns.length);
  },

  // 미리보기 생성
generatePreview: async (fileId, selectedColumnsParam = null, headerRows = 6, previewRows = 10) => {
  // 🔥 수정: 파라미터로 전달된 컬럼이 있으면 우선 사용, 없으면 store의 selectedColumns 사용
  const { selectedColumns } = get();
  const columnsToUse = selectedColumnsParam || selectedColumns;
  
  if (columnsToUse.length === 0) {
    set({ previewError: '선택된 컬럼이 없습니다.' });
    return { success: false, error: '선택된 컬럼이 없습니다.' };
  }
  
  set({ isLoadingPreview: true, previewError: null });
  
  try {
    //console.log('[TRIM_STORE]', 'Generating preview for', columnsToUse.length, 'columns');
    //console.log('[TRIM_STORE]', 'Using columns:', columnsToUse);
    
    const result = await trimAPI.generatePreview(fileId, columnsToUse, headerRows, previewRows);
    
    if (result.success) {
      set({
        previewData: result.data.preview,
        isLoadingPreview: false,
        previewError: null
      });
      
      //console.log('[TRIM_STORE]', 'Preview generated:', result.data.preview);
      return { success: true, data: result.data };
    } else {
      throw new Error(result.message);
    }
    
  } catch (error) {
    console.error('[TRIM_STORE]', 'Preview error:', error);
    const errorInfo = handleApiError(error);
    
    set({
      isLoadingPreview: false,
      previewError: errorInfo.message,
      previewData: null
    });
    
    return { success: false, error: errorInfo.message };
  }
},

  // 트림 실행
executeTrim: async (fileId, selectedColumnsParam = null, outputFilename, headerRows = 6) => {
  // 🔥 수정: 파라미터로 전달된 컬럼이 있으면 우선 사용, 없으면 store의 selectedColumns 사용
  const { selectedColumns, outputFileName } = get();
  const columnsToUse = selectedColumnsParam || selectedColumns;
  const filenameToUse = outputFilename || outputFileName;
  
  if (columnsToUse.length === 0) {
    set({ generationError: '선택된 컬럼이 없습니다.' });
    return { success: false, error: '선택된 컬럼이 없습니다.' };
  }
  
  if (!filenameToUse.trim()) {
    set({ generationError: '파일명을 입력해주세요.' });
    return { success: false, error: '파일명을 입력해주세요.' };
  }
  
  set({ isGenerating: true, generationError: null });
  
  try {
    //console.log('[TRIM_STORE]', 'Executing trim:', filenameToUse);
    //console.log('[TRIM_STORE]', 'Using columns:', columnsToUse);
    
    const result = await trimAPI.executeTrim(fileId, columnsToUse, filenameToUse, headerRows);
    
    if (result.success) {
      set({
        isGenerating: false,
        generationError: null,
        downloadLink: result.data.filename // 실제 다운로드 링크는 backend에서 제공
      });
      
      //console.log('[TRIM_STORE]', 'Trim executed successfully:', result.data.filename);
      return { success: true, data: result.data };
    } else {
      throw new Error(result.message);
    }
    
  } catch (error) {
    console.error('[TRIM_STORE]', 'Execution error:', error);
    const errorInfo = handleApiError(error);
    
    set({
      isGenerating: false,
      generationError: errorInfo.message,
      downloadLink: null
    });
    
    return { success: false, error: errorInfo.message };
  }
},

  // 에러 클리어
  clearErrors: () => {
    set({
      analysisError: null,
      previewError: null,
      generationError: null
    });
  },

  // 상태 초기화
reset: () => {
  set({
    selectedFile: '',
    columnStructure: null,
    columns: [],
    selectedColumns: [],
    selectAll: false,
    previewData: null,
    outputFileName: 'selected_data',
    isAnalyzing: false,
    isLoadingPreview: false,
    isGenerating: false,
    analysisError: null,
    previewError: null,
    generationError: null,
    downloadLink: null,
    
    // 🔥 트리 관련 상태들도 모두 초기화
    treeData: null,
    terminalNodes: [],
    checkedNodes: new Set(),
    selectedTreeData: null,
    selectedCheckedNodes: new Set(),
    finalSelectedNodes: []
  });
  //console.log('🔥 [DEBUG] Store reset 완료 - 모든 상태 초기화됨');
},
}));

export default useTrimStore;